import styled from "styled-components";

export const Wrapper = styled.section`
  padding:10px 16px ;
  gap: 32px;
  position: relative;

  @media (min-width: 768px){
    padding: 32px 64px;
  }

  @media (min-width: 1440px) {
    padding: 48px 120px;
  }
`;

export const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 0 auto;
  margin-bottom: 42px;
  max-width: 1200px;

  h2{
    font-weight: 600;
    font-style: bold;
    font-size: 24px;
    line-height: 32px;
    letter-spacing: 0px;
    text-align: center;

    @media (min-width: 850px){
      font-size: 32px;
      line-height: 40px;
      letter-spacing: 1px;
    }
  }

  p{
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0px;
    text-align: center;
  }
`

export const CardBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 48px;   
  max-width: 1200px;
  margin: 0 auto;

  @media (min-width: 700px){
    gap: 48px 8px;
  }

  @media (min-width: 1000px){
   width: 48% 0;
 }
`
export const CardWidth = styled.div`
 width: 100%;

 @media (min-width: 700px){
   width: 49%;
 }

 @media (min-width: 1000px){
   width: 30%;
 }
`